var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/domain-edit.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-bc3b9778!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/domain-edit.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/DomainEdit.vue
// module id = 617
// module chunks = 1